export const FETCH_OUTDOOR_CONDITIONS_REQUEST = 'FETCH_OUTDOOR_CONDITIONS_REQUEST';
export const FETCH_OUTDOOR_CONDITIONS_SUCCESS = 'FETCH_OUTDOOR_CONDITIONS_SUCCESS';
export const FETCH_OUTDOOR_CONDITIONS_FAILURE = 'FETCH_OUTDOOR_CONDITIONS_FAILURE';
